import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { phoneChange, startOrderRequest } from '../../stateManagement/engine/actions/OrderActions';
import { connect } from 'react-redux';
import IdleContent from './IdleContent';

function mapStateToProps(state) {
  return {
    phone: state.order.phone,
    error: state.order.error,
    countryCode: _.get(state, 'session.organization.address.countryCode'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      phoneChange,
      startOrderRequest,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(IdleContent);
